/**
 * Inställningar › Aviseringar › Påminnelser till externa utförare
 * (molnfast-react#1613): the default the assignment composer starts from and
 * iOS delegations get. Changing it never touches orders already delegated.
 */
import React, { useEffect, useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import ReminderFields from '../../Components/WorkOrderReminders/ReminderFields';
import { useReminderDefaults } from '../../hooks/workOrders/useReminderDefaults';
import { ReminderDraft, draftFromTiming, timingFromDraft } from '../../types/workOrderReminders';

const WorkOrderReminderSettings: React.FC = () => {
    const { defaults, loading, saving, error, save } = useReminderDefaults();
    const [draft, setDraft] = useState<ReminderDraft>(draftFromTiming(defaults));
    const [formError, setFormError] = useState<string | null>(null);
    const [saved, setSaved] = useState(false);

    useEffect(() => {
        setDraft(draftFromTiming(defaults));
    }, [defaults]);

    const handleSave = async () => {
        setSaved(false);
        const result = timingFromDraft(draft);
        if (result.error !== undefined) {
            setFormError(result.error);
            return;
        }
        setFormError(null);
        try {
            await save(result.timing ?? {});
            setSaved(true);
        } catch {
            // error shown from the hook
        }
    };

    return (
        <section className="mt-5" style={{ maxWidth: 560 }}>
            <h2 className="h5">Påminnelser till externa utförare</h2>
            <p className="text-muted">
                När ett ärende med förfallodatum delegeras till en extern användare skickas påminnelser per e-post
                med länk till ärendet. Här anger du förvalet; det kan ändras för varje ärende. Ändringar här
                påverkar inte ärenden som redan är delegerade.
            </p>
            {(error || formError) && <Alert variant="danger">{formError ?? error}</Alert>}
            {saved && <Alert variant="success" onClose={() => setSaved(false)} dismissible>Påminnelserna är sparade.</Alert>}
            <ReminderFields
                draft={draft}
                onChange={setDraft}
                idPrefix="reminder-defaults"
                disabled={loading || saving}
                toggle={false}
            />
            <Button className="mt-3" variant="primary" onClick={() => { void handleSave(); }} disabled={loading || saving}>
                {saving ? 'Sparar…' : 'Spara'}
            </Button>
        </section>
    );
};

export default WorkOrderReminderSettings;
